import {PolymerElement, html} from '@polymer/polymer';
import {ScopeBinding} from '../behaviors/keli-binding-behavior.js';
import {InputBehavior} from '../behaviors/input-behavior.js';
import {InputSharedStylesHTML} from '../shared-styles/input.js';

class KeliEmail extends ScopeBinding(InputBehavior(PolymerElement)) {
  static get template() {
    return html`
${InputSharedStylesHTML}

<keli-input-container id="container"
    label="[[caption]]"
    input-has-content="[[active]]"
    icon="[[icon]]"
    always-float-label="[[masked]]"
    focused="[[focused]]"
    disabled="[[disabled]]"
    invalid="[[invalid]]"
    error-message="[[errorMessage]]"
    hotkey="[[formattedShortcutKey]]"
    max-length="[[maxLength]]"
    current-length="[[currentValueLength]]"
    chrome="[[chrome]]"
    help-text="[[helpText]]">

  <input type="email" multiple id="input" value="{{currentValue::input}}" slot="input">
</keli-input-container>`;
  }

  static get is() {
    return 'keli-email';
  }

  static get properties() {
    return {
      keliControlTypes: {type: Array, value: ['email']},
      validateOnBlur: {type: Boolean, value: true},
      showOverflowTooltip: {type: Boolean, value: true}
    }
  }
}

customElements.define(KeliEmail.is, KeliEmail);
export {KeliEmail};
